var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "ci-user-profile-description ci-card ci-section ci-content-padding",
    },
    [
      _c("h3", {
        staticClass: "h5",
        domProps: {
          textContent: _vm._s(
            _vm.$t("ui.components.users.profile.description.title")
          ),
        },
      }),
      _c("p", { domProps: { textContent: _vm._s(_vm.textWithFallback) } }),
      !_vm.text
        ? _c(
            "div",
            { staticClass: "row flex-center" },
            [
              _c("ci-button", {
                attrs: {
                  icon: "mdi-plus",
                  label: _vm.$t(
                    "ui.components.users.profile.description.action"
                  ),
                  to: {
                    name: _vm.$routes.USERS_EDIT,
                    params: { id: _vm.slug },
                    hash: "#areaaboutme",
                  },
                  variant: "outline-primary",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }